<template>
  <div>
    <h2>Questions</h2>
  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  name: "Questions",
  setup() {
    onMounted(() => {
      console.log("Questions");
    });
  },
};
</script>
